import { render, staticRenderFns } from "./ebp-divider.vue?vue&type=template&id=5c7ee87a"
import script from "./ebp-divider.vue?vue&type=script&lang=js"
export * from "./ebp-divider.vue?vue&type=script&lang=js"
import style0 from "./ebp-divider.vue?vue&type=style&index=0&id=5c7ee87a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports